<template>
  <b-modal id="slidesModal" ref="slidesModal" size="lg" hide-header hide-footer lazy modal-class="slides" v-if="image">
    <a href @click.stop.prevent="previous()" class="paginate prev" v-show="!isFirst()">
      <i class="icon-PREVIOUS"></i>
    </a>

    <div class="image-container">
      <img :src="src" v-if="image" />
      <div>{{ image.copyright }}</div>
    </div>

    <a @click.stop.prevent="next()" class="paginate next" v-show="!isLast()">
      <i class="icon-Next"></i>
    </a>

    <a class="close" @click.stop.prevent="hide()" :class="{ last: isLast() }">
      <i class="icon-notice_close">&nbsp;</i>
    </a>
  </b-modal>
</template>
<script>
export default {
  name: 'MovementSlidesModal',
  props: ['image', 'next', 'previous', 'isLast', 'isFirst'],
  methods: {
    hide() {
      this.$refs.slidesModal.hide();
    },
  },
  computed: {
    src() {
      if (!this.image) {
        return;
      }
      return this.image.url_template.supplant({
        size: 1000,
        file_name: this.image.file_name,
      });
    },
  },
};
</script>
